var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: 1440,
    height: 1019,
    viewBox: "0 0 1440 1019",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "css-1x8tl5h e1kxj17c4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M397.764 2.10938V601.199L0.000976562 713.573",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M462.189 2.10938V601.198L0.00195312 764.407",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M526.61 2.10938V601.199L0.000488281 849.105",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M591.039 2.10938V601.199L0.307617 1018.21",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M655.462 2.10938V601.199L359.842 1018.21",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M719.885 2.10938V601.199L719.382 1018.21",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M784.314 2.10938V601.199L1078.91 1018.21",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M848.736 2.10938V601.199L1438.45 1018.21",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M913.165 2.10938V601.199L1440 849.493",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M977.587 2.10938V601.199L1440 764.624",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.01 2.10938V601.198L1440 713.715",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.44 2.10938V601.199L1440 679.779",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.86 2.10938V601.198L1440 655.542",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.29 2.10938V601.199L1440 637.366",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1299.71 2.10938V601.199L1440 623.228",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.14 2.10938V601.199L1440 611.922",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.56 2.10938V601.199L1440 602.667",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 655.469L268.913 601.198V2.10938",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M333.336 2.10938V601.199L0.000488281 679.681",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M204.492 2.10938V601.199L0 637.313",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M140.062 2.10938V601.198L0.00195312 623.183",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6398 2.10938V601.199L0.000488281 611.882",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.21 2.10938V601.198L0.000488281 602.638",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 555.74H1440",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 510.277H1440",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 464.819H1440",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 419.361H1440",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 373.897H1440",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 328.439H1440",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 282.981H1440",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 237.517H1440",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 192.059H1440",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 146.601H1440",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 101.137H1440",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 55.6793H1440",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.786729H1440",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 801.202H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 766.064H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 738.5H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 847.522H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 716.293H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 698.024H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 605.284H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 601.199H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 614.662H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 609.754H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 658.563H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 682.726H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 911.383H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 626.096H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 620.084H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 648.855H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 640.334H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 632.803H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 669.735H0",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1438.45 1018.21H0.307129",
    stroke: "#7A7A7A",
    strokeOpacity: 0.4,
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.993204125a57820957a246a0d75c52c3.svg";
export { ForwardRef as ReactComponent };